import { z } from "zod";
import { ZDateish } from "./commonSchema";
import { ZDateTime, ZObjectIdString, ZUserPartial } from "./issueBoardSchema";
export const ZChecklistLogBaseSchema = z.object({
    _id: ZObjectIdString,
    project: ZObjectIdString,
    board: ZObjectIdString,
    rowId: ZObjectIdString.optional().nullable(),
    column: z.string(),
    oldValue: z.string().optional().nullable(),
    newValue: z.string().optional().nullable(),
});
export const ZChecklistLogDbSchema = ZChecklistLogBaseSchema.extend({
    user: ZObjectIdString,
    createdAt: ZDateTime,
    updatedAt: ZDateTime.optional().nullable(),
});
const ZChecklistLogApiSchemaRaw = ZChecklistLogBaseSchema.extend({
    user: ZUserPartial,
    rowId: z
        .object({
        _id: ZObjectIdString,
        itemId: z.number(),
        title: z.string(),
    })
        .optional()
        .nullable(),
    createdAt: ZDateish,
    updatedAt: ZDateish.optional().nullable(),
});
export const ZChecklistLogApiSchema = ZChecklistLogApiSchemaRaw;
const ZChecklistRowLogApiSchemaRaw = z
    .object({
    _id: ZObjectIdString,
    column: z.string(),
    columnDisplayName: z.string().optional(),
    createdAt: ZDateish,
    newValue: z.string().optional().nullable(),
    oldValue: z.string().optional().nullable(),
    updatedAt: ZDateish.optional().nullable(),
    userName: z.string().optional(),
    user: ZUserPartial.optional().nullable(),
})
    .passthrough();
export const ZChecklistRowLogApiSchema = ZChecklistRowLogApiSchemaRaw;
